/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModalityQuotaStatusDto
 */
export interface ModalityQuotaStatusDto {
    /**
     * Total modality quota available for the practice
     * @type {number}
     * @memberof ModalityQuotaStatusDto
     */
    quota: number;
    /**
     * Number of modality slots already used
     * @type {number}
     * @memberof ModalityQuotaStatusDto
     */
    used: number;
    /**
     * Number of modality slots available for use
     * @type {number}
     * @memberof ModalityQuotaStatusDto
     */
    available: number;
}

/**
 * Check if a given object implements the ModalityQuotaStatusDto interface.
 */
export function instanceOfModalityQuotaStatusDto(value: object): value is ModalityQuotaStatusDto {
    if (!('quota' in value) || value['quota'] === undefined) return false;
    if (!('used' in value) || value['used'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    return true;
}

export function ModalityQuotaStatusDtoFromJSON(json: any): ModalityQuotaStatusDto {
    return ModalityQuotaStatusDtoFromJSONTyped(json, false);
}

export function ModalityQuotaStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModalityQuotaStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'quota': json['quota'],
        'used': json['used'],
        'available': json['available'],
    };
}

export function ModalityQuotaStatusDtoToJSON(json: any): ModalityQuotaStatusDto {
    return ModalityQuotaStatusDtoToJSONTyped(json, false);
}

export function ModalityQuotaStatusDtoToJSONTyped(value?: ModalityQuotaStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quota': value['quota'],
        'used': value['used'],
        'available': value['available'],
    };
}

